<div class="modal-content">
  <div class="modal-header">
    <div class="modal-title">
      <img class="wpp-icon" src="assets/icons/channels/whatsapp.svg" alt="WhatsApp" />
      <h2>{{ 'CREDITS_BALANCE.TITLE' | translate }}</h2>
    </div>
    <ask-button-v2 appearance="transparent" (click)="closeModal()" data-testid="credits-balance-close">
      <ask-icon-v2 name="close" matFontSet="material-symbols-outlined"></ask-icon-v2>
    </ask-button-v2>
  </div>

  <div class="modal-subtitle">{{ 'CREDITS_BALANCE.SUBTITLE' | translate }}</div>

  <div class="modal-body">
    @if (loading$ | async) {
      <div class="modal-loading" [askSpinner]="true" spinnerSize="medium"></div>
    } @else {
    @for (balance of balances$ | async; track balance.name) {
      <div class="balance-row" [ngClass]="balance.severityClass">
        <div class="balance-head">
          <span class="balance-name">{{ balance.name }}</span>
          <span class="balance-used">{{ balance.used }}% {{ 'CREDITS_BALANCE.USED' | translate }}</span>
        </div>

        <div class="balance-bar">
          <div class="balance-bar-fill" [style.width]="balance.usedWidth"></div>
        </div>

        <div class="balance-foot">
          <span class="balance-messages">
            {{ 'CREDITS_BALANCE.MESSAGES_USED' | translate: { used: balance.usedCountLabel, total: balance.totalLabel } }}
            @if (balance.renewDate) {
              ({{ 'CREDITS_BALANCE.RENEWS' | translate: { date: balance.renewDate } }})
            }
          </span>

          <!-- INFO: Commented because runOutDate cannot be infered for all companies right now -->
          <!-- Uncomment when runOutDate gets fixed for all cases -->
          <!-- @if (balance.runOutDate) { -->
          <!--   <span class="balance-note"> -->
          <!--     {{ 'CREDITS_BALANCE.NOTE_ENDS' | translate: { date: balance.runOutDate } }} -->
          <!--   </span> -->
          <!-- } -->
        </div>

        @if (balance.warn) {
          <div class="balance-warn">
            <ask-icon-v2 class="warn-icon" name="warning" matFontSet="material-symbols-outlined"></ask-icon-v2>
            <span>
              @if (balance.level === 3) {
                {{ 'CREDITS_BALANCE.WARN_EMPTY' | translate }}
              } @else if (balance.level === 2) {
                {{ 'CREDITS_BALANCE.WARN_CRITICAL' | translate }}
              } @else {
                {{ 'CREDITS_BALANCE.WARN_HALF' | translate }}
              }
            </span>
          </div>
        }
      </div>
    }
    }
  </div>

  <div class="modal-footer">
    <a
      class="buy-link"
      href="https://admin.asksuite.com/whatsapp/credits-statement"
      target="_blank"
      rel="noopener noreferrer"
    >{{ 'CREDITS_BALANCE.BUY' | translate }}</a>
  </div>
</div>
